import { PropsWithChildren } from "react";
import styles from "./PageWrapper.module.css";

export const PageWrapper = ({ children }: PropsWithChildren<{}>) => (
  <div className={styles.pageWrapper}>{children}</div>
);
